import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Image, ImageType } from 'src/app/models/image.model';
import { MeterValidationDetails } from 'src/app/models/meter-validation.model';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';
import { MeterValidationService } from 'src/app/services/meter-validation.service';
import { PermissionsService } from 'shared-lib';
import { TranslationService } from 'src/app/services/translation.service';
import { UserService } from 'src/app/services/user.service';
import { ImageService } from 'src/app/services/image.service';

@Component({
  selector: 'app-meter-validation-details',
  templateUrl: './meter-validation-details.component.html',
  styleUrls: ['./meter-validation-details.component.scss'],
})
export class MeterValidationDetailsComponent implements OnInit {
  id: string = '';
  selectedMeterValidation: MeterValidationDetails =
    new MeterValidationDetails();
  selectedImage: any;

  buName: string = this.translationService.getByKeyFromStorage('BU');
  utName: string = this.translationService.getByKeyFromStorage('UT');
  ImageType = ImageType;
  imgElement: any;
  imgZoomFullContainer: any;
  currentRotation: number = 0;
  isMapVisible: boolean = false;
  filterText = '';
  rejectToOption: string;
  tempAssignedUserId: number = 0;
  mobileUsers: User[] = [];
  isDropdownOpened: boolean = false;
  rejectionNote: string = '';
    tamperImages: Image[] = [];

  constructor(
    private route: ActivatedRoute,
    private meterValidationService: MeterValidationService,
    private translationService: TranslationService,
    private el: ElementRef,
    private renderer: Renderer2,
    private toastr: ToastrService,
    private userService: UserService,
    public permissionsService: PermissionsService,
    private authService: AuthService,
    private imageService: ImageService
  ) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id') || '';
    this.imgElement = this.el?.nativeElement?.querySelector(
      '.ngxImageZoomThumbnail'
    );
    this.imgZoomFullContainer =
      this.el?.nativeElement?.querySelector('.ngxImageZoomFull');

    this.getSelectedMeterValidation(parseInt(this.id));
  }

  getSelectedMeterValidation(id: number) {
    this.meterValidationService.get(id).subscribe({
      next: (data) => {
        this.selectedMeterValidation = data.body!.data;
        this.tamperImages = this.selectedMeterValidation.images.filter(
          (x) => x.imageType.toString().startsWith('Tamper')
        );
      },
      error: (err) => {
        this.toastr.error('An error ocurred.');
      },
    });
  }

  onModalFade() {
    this.currentRotation = 0;

    if (this.imgZoomFullContainer) {
      var displayValue = getComputedStyle(this.imgZoomFullContainer).display;

      if (displayValue == 'block') {
        this.imgElement.click();
      }
    }
  }

  rotateLeft() {
    this.currentRotation -= 90;
  }

  rotateRight() {
    this.currentRotation += 90;
  }

  onModalOpen() {
    this.renderer.setStyle(document.body, 'overflow', 'auto');
    this.renderer.setStyle(document.body, 'overflow-x', 'hidden');
    this.renderer.setStyle(document.body, 'padding-right', '0');
  }

  getImageByType(imageType?: ImageType) {
    return (
      this.selectedMeterValidation.images?.find(
        (x) => this.getImageTypeFromString(x.imageType?.toString()) === imageType
      )
    );
  }

  showImage(imageType?: ImageType, index?: number) {
    if (imageType) {
      this.selectedImage = this.getImageByType(imageType); 
    }
    else this.selectedImage = this.getTamperImage(index!);
    this.getSelectedImageAddress();
  }

  getSelectedImageAddress() {
    const image = this.selectedImage;
    if (!image?.latitude || !image?.longitude || image.physicalAddress) return;

    this.imageService.getAddress({ latitude: image.latitude, longitude: image.longitude }).subscribe((data) => {
      if (data.body?.status === 'OK') {
        image.physicalAddress = data.body.data;
      }
    });
  }

  getImageTypeFromString(typeStr: string): ImageType | undefined {
    if (typeStr in ImageType) {
      return ImageType[typeStr as keyof typeof ImageType];
    }
    return undefined;
  }

  getTamperImage(index: number) {
    if (this.tamperImages && this.tamperImages.length > 0) {
      return this.tamperImages[index];
    }

    return undefined;
  }

  filterMobileUsers() {
    if (this.filterText.length < 3) {
      return;
    }
    this.isDropdownOpened = true;
    this.tempAssignedUserId = 0;
    this.getMobileUsers();
  }

  getMobileUsers() {
    const areaId = this.authService.hasCimDataIntegration
      ? this.selectedMeterValidation.subgeographicalRegionId
      : this.selectedMeterValidation.areaId;
    this.userService.getMobileUsers(areaId, this.filterText).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.mobileUsers = responseData.data;
          if (this.mobileUsers.length == 0) {
            this.isDropdownOpened = false;
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  selectFieldAgent(id: number) {
    this.isDropdownOpened = false;
    this.tempAssignedUserId = id;
    var mobUser = this.mobileUsers.find((x) => x.id == id);
    if (mobUser?.firstName && mobUser?.lastName) {
      this.filterText = mobUser!.firstName + ' ' + mobUser?.lastName;
    } else {
      this.filterText = mobUser!.firstName;
    }
  }
  
  onOptionChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.rejectToOption = target.value;
    this.tempAssignedUserId = 0;
    this.filterText = '';
  }

  reject() {
    let obj = {
      id: this.selectedMeterValidation.id,
      note: this.rejectionNote,
      assignToId: this.tempAssignedUserId,
    };
    if(this.rejectToOption === 'fieldAgent' && this.tempAssignedUserId === 0) 
      this.toastr.error('Select field Agent');
    else
      this.meterValidationService.rejectMeterValidation(obj).subscribe(
        (data) => {
          this.toastr.success('Meter Validation Rejected');
          window.location.reload();
        },
        (error) => {
          this.toastr.error('An error ocurred.');
        }
      );
  }

  approve() {
    this.meterValidationService.approveMeterValidation(this.selectedMeterValidation.id).subscribe(
      (data) => {
        this.toastr.success('Meter Validation Approved');
        window.location.reload();
      },
      (error) => {
        this.toastr.error('An error ocurred.');
      }
    );
  }
}
